var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"1rem","border-radius":"4px","margin":"auto 10px 12px"}},[_c('span',{staticClass:"pa-1 label-primary",staticStyle:{"font-size":"1rem","border-radius":"4px"}},[_vm._v(_vm._s(_vm.computed_count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }